import setFieldValue from "@iewcasia/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/RfqRequestQuote/FormBaseComponent";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.textFields,
};

const mapStateToProps = (state: CustomState) => ({
    firstName: state.customRequestQuoteForm.fieldValues.firstName,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const FirstNameWidget: React.FC<Props> = ({ fields: widgetFields, firstName, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, firstName, "firstName", () =>
        validateFieldBy(isRequired, label, firstName, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "firstName", value: event.target.value });
    };

    return (
        <TextField
            {...styles}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={firstName || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(FirstNameWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("First Name"),
            getRfqFormHintTextBuilt("Enter First Name"),
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
